export enum CommissionTypes {
    ALL = 'All',
    DIRECT_SALES = 'Direct Sales',
    BINARY_CYCLES = 'Binary Cycles',
    MATHICNG_BONUS = 'Matching Bonus',
    INCENTIVES = 'Incentives',
    MISSED_COMMISIONS = 'Missed Commissions',
    CLAIMED_COMMISSIONS = 'Claimed Commissions',
}
